import { render, staticRenderFns } from "./Tiyudanzhao.vue?vue&type=template&id=0a46f587&scoped=true"
import script from "./Tiyudanzhao.vue?vue&type=script&lang=js"
export * from "./Tiyudanzhao.vue?vue&type=script&lang=js"
import style0 from "./Tiyudanzhao.vue?vue&type=style&index=0&id=0a46f587&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46f587",
  null
  
)

export default component.exports